import * as anchor from "@project-serum/anchor"

const testWalletAddress = ""
//const testWalletAddress = "5AVRhXArbTEF7qHYHDFKETYzwTw42NiYbMhU7mgdfraU"

export const testWallet = testWalletAddress === "" ? "" : new anchor.web3.PublicKey(testWalletAddress)
